import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

/** « Voir les détails » : le dossier tel qu'il a été déposé, en lecture. */
export function UsRegistrationDetails({ open, onClose, details }: { open: boolean; onClose: () => void; details: Record<string, unknown> | null }) {
  const { t } = useTranslation()
  if (!details) return null
  const champs: Array<[string, string]> = [
    ['business_name', t('manager.trust.form.businessName')], ['business_type', t('manager.trust.form.businessType')],
    ['business_number', t('manager.trust.form.businessNumber')], ['industry', t('manager.trust.form.industry')],
    ['website', t('manager.trust.form.website')], ['business_email', t('manager.trust.form.businessEmail')],
    ['address1', t('manager.trust.form.address')], ['city', t('manager.trust.form.city')], ['province', t('manager.trust.form.province')], ['postal', t('manager.trust.form.postal')],
    ['rep_first_name', t('manager.trust.form.firstName')], ['rep_last_name', t('manager.trust.form.lastName')], ['rep_email', t('manager.trust.form.email')], ['rep_phone', t('manager.trust.form.phone')], ['rep_title', t('manager.trust.form.title')],
    ['use_case', t('manager.trust.form.useCase')], ['description', t('manager.trust.form.description')], ['sample1', t('manager.trust.form.sample1')], ['sample2', t('manager.trust.form.sample2')], ['consent', t('manager.trust.form.consent')],
    ['numbers', t('manager.trust.form.numbers')],
  ]
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent showCloseButton={false} className="sm:max-w-xl overflow-hidden border-0 p-0 shadow-2xl">
        <div className="h-1 w-full bg-gradient-to-r from-blue-600 via-blue-400 to-blue-600" />
        <div className="px-6 pt-6">
          <DialogTitle className="text-xl tracking-tight">{t('manager.trust.details')}</DialogTitle>
        </div>
        <dl className="px-6 pt-4 pb-2 max-h-[65vh] overflow-y-auto divide-y divide-slate-100 dark:divide-slate-800">
          {champs.map(([k, label]) => {
            const v = details[k]
            if (v === undefined || v === '' || v === null) return null
            const texte = Array.isArray(v) ? v.join(', ') : String(v)
            return (
              <div key={k} className="py-2 grid grid-cols-[160px_1fr] gap-3 text-sm">
                <dt className="text-slate-500 dark:text-slate-400">{label}</dt>
                <dd className="text-slate-900 dark:text-slate-100 break-words">{k === 'business_type' || k === 'rep_title' || k === 'use_case' ? t(`manager.trust.options.${k === 'business_type' ? 'businessTypes' : k === 'rep_title' ? 'titles' : 'useCases'}.${texte}`, texte) : texte}</dd>
              </div>
            )
          })}
        </dl>
        <div className="flex justify-end border-t bg-slate-50 dark:bg-slate-800/50 px-6 py-4">
          <Button type="button" variant="ghost" onClick={onClose}>{t('manager.trust.close')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
